import React from 'react';
import ModalValidarPago from './ModalValidarPago';

const VistaCobroExternos = (props) => {
  const {
    externos, externoSeleccionado, setExternoSeleccionado, loadingLista, montoManual, setMontoManual,
    handleAgregarAlCarrito, mensaje, carrito, procesarCobroPinpad, procesarCobroVentanilla, loading,
    handleAbrirHistorial, handleAbrirPendientes, setVistaActual, modalExito, setModalExito,
    modalPendientes, setModalPendientes, cargandoPendientes, datosPendientes, abrirModalValidacion,
    modalValidacion, refSeleccionada, folioBanco, setFolioBanco, confirmarValidacionPago, loadingValidacion,
    bancoSeleccionado, setBancoSeleccionado,
    abrirModalComplemento, cerrarModal, cobrarFaltantePinpad, cobrarFaltanteTPV,
    calcularFaltante, tienePinpad, modoModal
  } = props;

  const rolCajero = String(localStorage.getItem("cajero_rol"));
  // El Administrador (rol 1) puede consultar pendientes de cualquier plantel
  // pero nunca valida pagos; cualquier cajero real (rol 2 o 3) si puede.
  const puedeValidar = rolCajero === "2" || rolCajero === "3";

  return (
    <div className="cobro-layout">
      {/* Columna Izquierda: Formulario */}
      <div className="catalogo-section">
        <div className="catalogo-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div><h3>☕ Configuración de Cobro a Externos</h3><p>Selecciona la concesión e ingresa el monto.</p></div>
          {externoSeleccionado && (
            <div style={{ display: 'flex', gap: '10px' }}>
              <button className="btn-select historial" onClick={() => { handleAbrirHistorial(); setVistaActual('historial'); }} style={{ padding: '8px 15px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>📜 Historial</button>
              <button className="btn-select validar" onClick={handleAbrirPendientes} style={{ padding: '8px 15px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>🏦 Validar Pago</button>
            </div>
          )}
        </div>

        <div className="cobro-form-container">
          <div>
            <label className="filter-label">Concesionario / Externo</label>
            {loadingLista ? ( <div style={{ color: '#666', padding: '10px' }}>⏳ Cargando lista...</div> ) : (
              <select className="search-input" value={externoSeleccionado} onChange={(e) => setExternoSeleccionado(e.target.value)}>
                <option value="">-- Selecciona una opción --</option>
                {externos.map((ex) => ( <option key={ex.matricula} value={ex.matricula}>{ex.nombre}</option> ))}
              </select>
            )}
          </div>
          <div>
            <label className="filter-label">Importe a Cobrar Nuevo ($)</label>
            <input type="number" step="0.01" placeholder="0.00" className="search-input input-monto" value={montoManual} onChange={(e) => setMontoManual(e.target.value)} disabled={!externoSeleccionado} />
          </div>
          <button className="btn-preparar" onClick={handleAgregarAlCarrito} disabled={!externoSeleccionado || loadingLista}>🛒 Preparar Cobro</button>
          {mensaje.texto && ( <div className={`alert-box ${mensaje.tipo === 'success' ? 'alert-success' : 'alert-error'}`}><span className="alert-icon">{mensaje.tipo === 'success' ? '✅' : '⚠️'}</span>{mensaje.texto}</div> )}
        </div>
      </div>

      {/* Columna Derecha: Ticket */}
      <div className="ticket-section">
        <div className="ticket-card">
          <h3 className="ticket-title">Resumen del Pago</h3>
          {carrito ? (
            <>
              <div className="ticket-items-container">
                <div className="ticket-beneficiario"><p className="beneficiario-label">Beneficiario</p><p className="beneficiario-nombre">{carrito.nombre}</p></div>
                <div className="ticket-item"><span className="item-nombre">{carrito.descripcion}</span></div>
              </div>
              <div className="ticket-footer">
                <div className="ticket-total"><span>TOTAL:</span><span className="total-monto">${carrito.precio.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span></div>
                <div className="btn-action-container">
                  {rolCajero === "2" && (
                    <button className="btn-pagar-grande" onClick={procesarCobroPinpad} disabled={loading}>{loading ? 'Procesando...' : '💳 Cobrar con Pinpad'}</button>
                  )}
                  <button className="btn-pagar-grande btn-pagar-verde" onClick={procesarCobroVentanilla} disabled={loading}>{loading ? 'Procesando...' : '🏦 Generar Referencia'}</button>
                </div>
              </div>
            </>
          ) : ( <div className="ticket-vacio"><span className="vacio-icono">🛒</span>No hay conceptos en preparación</div> )}
        </div>
      </div>

      {/* --- MODAL DE REFERENCIAS PENDIENTES (TARJETAS) --- */}
      {modalPendientes && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '750px', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
            <div className="modal-header"><h2>🏦 Referencias Pendientes en Ventanilla</h2></div>

            <div style={{ overflowY: 'auto', flex: 1, paddingRight: '5px', marginTop: '10px' }}>
              {cargandoPendientes ? (
                <p>⏳ Cargando referencias...</p>
              ) : datosPendientes.length > 0 ? (
                datosPendientes.map((ref) => {
                  const esParcial = ref.estatus === "PARCIAL";
                  const total = parseFloat(ref.importe_total || 0);
                  const abonado = parseFloat(ref.abonado || 0);
                  const faltante = +(total - abonado).toFixed(2);

                  return (
                    <div key={ref.id} style={{
                      border: esParcial ? '2px solid #f0ad4e' : '1px solid #ccc',
                      padding: '15px', marginBottom: '15px', borderRadius: '8px',
                      backgroundColor: esParcial ? '#fffdf5' : '#fff',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                    }}>
                      {esParcial && (
                        <div style={{
                          marginBottom: '12px', padding: '8px 12px', borderRadius: '4px',
                          backgroundColor: '#fff3cd', border: '1px solid #ffe082',
                          color: '#7a5c00', fontSize: '0.85rem', fontWeight: 'bold'
                        }}>
                          Pago parcial: se abonaron ${abonado.toFixed(2)} de ${total.toFixed(2)}. Falta ${faltante.toFixed(2)}.
                        </div>
                      )}

                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '10px', flexWrap: 'wrap', gap: '10px' }}>
                        <div>
                          <h4 style={{ margin: '0 0 5px 0', color: '#0056b3' }}>
                            Ref. Banorte: <span style={{ color: '#333' }}>{ref.referencia_banorte || 'N/A'}</span>
                          </h4>
                          <h4 style={{ margin: '0 0 8px 0', color: '#0056b3' }}>
                            Ref. BBVA: <span style={{ color: '#333' }}>{ref.referencia_bbva || 'N/A'}</span>
                          </h4>
                          <span style={{ fontSize: '0.9rem', color: '#666' }}>
                            Generada el: {ref.fecha_creacion} a las {ref.hora_creacion}
                          </span>
                        </div>

                        <div style={{ textAlign: 'right', minWidth: '210px' }}>
                          {esParcial ? (
                            <>
                              <div style={{ fontSize: '0.8rem', color: '#777', textDecoration: 'line-through' }}>
                                ${total.toFixed(2)}
                              </div>
                              <h3 style={{ color: '#d9534f', margin: '2px 0 10px 0' }}>
                                Falta ${faltante.toFixed(2)}
                              </h3>
                              {puedeValidar && (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                  <button
                                    onClick={() => abrirModalComplemento(ref)}
                                    disabled={loadingValidacion}
                                    className="btn-select"
                                    style={{ fontSize: '0.85rem', padding: '6px 12px', backgroundColor: '#0056b3', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                  >
                                    {tienePinpad ? "Cobrar faltante con Pinpad" : "Cobrar faltante con TPV"}
                                  </button>
                                  <button
                                    onClick={() => abrirModalValidacion(ref)}
                                    disabled={loadingValidacion}
                                    className="btn-select validar"
                                    style={{ fontSize: '0.85rem', padding: '6px 12px' }}
                                  >
                                    Validar segundo voucher
                                  </button>
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              <h3 style={{ color: '#28a745', margin: '0 0 8px 0' }}>${total.toFixed(2)}</h3>
                              {puedeValidar && (
                                <button
                                  onClick={() => abrirModalValidacion(ref)}
                                  disabled={loadingValidacion}
                                  className="btn-select validar"
                                  style={{ fontSize: '0.9rem', padding: '6px 12px' }}
                                >
                                  Validar Voucher
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>

                      <div>
                        <strong style={{ fontSize: '0.9rem' }}>Conceptos incluidos:</strong>
                        <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '0.9rem', color: '#444' }}>
                          {ref.conceptos && ref.conceptos.length > 0 ? (
                            ref.conceptos.map((concepto, index) => (
                              <li key={index}>
                                {concepto.descripcion} <span style={{ color: '#888' }}>(${concepto.precio_unitario})</span>
                              </li>
                            ))
                          ) : (
                            <li>Sin detalle de conceptos.</li>
                          )}
                        </ul>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div style={{ textAlign: 'center', padding: '30px', color: '#999' }}>No hay referencias pendientes.</div>
              )}
            </div>

            <div className="modal-actions" style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
              <button className="btn-logout" onClick={() => setModalPendientes(false)}>Cerrar Ventana</button>
            </div>
          </div>
        </div>
      )}

      {modalExito.visible && (
        <div className="modal-overlay-exito">
          <div className="modal-card-exito">
            <div className="modal-icon-exito">🎉</div><h2 className="modal-title-exito">¡Cobro Registrado con Éxito!</h2>
            <div className="modal-detalles-exito">
              <div className="detalle-row-exito"><span>Concesionario:</span><strong>{modalExito.nombre}</strong></div>
              <div className="detalle-row-exito"><span>Monto:</span><strong className="monto-resaltado-exito">${modalExito.monto.toLocaleString('en-US', { minimumFractionDigits: 2 })} MXN</strong></div>
              <div className="detalle-row-exito"><span>No. Autorización:</span><strong className="codigo-exito">{modalExito.autorizacion}</strong></div>
              <div className="detalle-row-exito"><span>Referencia:</span><strong className="codigo-exito">{modalExito.referencia}</strong></div>
            </div>
            <button className="btn-modal-aceptar-exito" onClick={() => setModalExito({ ...modalExito, visible: false })}>Aceptar y Continuar</button>
          </div>
        </div>
      )}

      {/* COMPONENTE MODAL DE VALIDACIÓN UNIFICADO */}
      <ModalValidarPago
        mostrar={modalValidacion && !!refSeleccionada}
        onClose={cerrarModal}
        onConfirm={confirmarValidacionPago}
        loading={loadingValidacion}
        datosPago={refSeleccionada ? {
          importe: refSeleccionada.importe_total,
          abonado: refSeleccionada.abonado,
          estatus: refSeleccionada.estatus,
          referenciaBanorte: refSeleccionada.referencia_banorte,
          referenciaBBVA: refSeleccionada.referencia_bbva,
          folioTPV: refSeleccionada.folio_tpv
        } : null}
        bancoSeleccionado={bancoSeleccionado}
        setBancoSeleccionado={setBancoSeleccionado}
        folioBanco={folioBanco}
        setFolioBanco={setFolioBanco}
        modoModal={modoModal}
        tienePinpad={tienePinpad}
        onCobrarPinpad={() => cobrarFaltantePinpad(refSeleccionada)}
        onCobrarTPV={(folio) => cobrarFaltanteTPV(refSeleccionada, folio)}
        faltante={calcularFaltante ? calcularFaltante(refSeleccionada) : 0}
      />
    </div>
  );
};

export default VistaCobroExternos;